import http from './http'

// 我的成就分页查询
export async function myAchievementPage(params = {}) {
  const res = await http.get('/achievement/achievement/page', { params })
  return res.data
}

// 根据类型与ID查看成就详情
export async function achievementDetail(payload) {
  const res = await http.post('/achievement/achievement/detail', payload)
  return res.data
}

// 根据类型与ID删除成就
export async function deleteAchievement(payload) {
  const res = await http.delete('/achievement/achievement', { data: payload })
  return res.data
}
